const initState = {
  consultas: [],
  activa: -1,
  parseoPrivadas: false,
  parseoPublicas: false,
};

const consultaDinamicaReducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_CONSULTAS_DINAMICAS': {
      const consultasActuales = state.consultas;
      const uniquePaths = new Set(consultasActuales.map((c) => c.ruta));
      const nuevasConsultas = action.payload.filter((nc) => !uniquePaths.has(nc.ruta));
      return {
        ...state,
        consultas: [
          ...consultasActuales,
          ...nuevasConsultas
        ]
      };
    }
    case 'SET_ACTIVE_CONSULTA': {
      return {
        ...state,
        activa: action.payload
      };
    }
    case 'BORRAR_CONSULTAS_PRIVADAS': {
      const consultasPrivadas = state.consultas.filter((i) => i.private);
      const privatePaths = new Set(consultasPrivadas.map((pq) => pq.ruta));
      return {
        ...state,
        consultas: [...state.consultas.filter((q) => !privatePaths.has(q.ruta))]
      };
    }
    case 'BORRAR_CONSULTAS_PUBLICAS': {
      const consultasPublicas = state.consultas.filter((i) => i.public);
      const publicPaths = new Set(consultasPublicas.map((pq) => pq.ruta));
      return {
        ...state,
        consultas: [...state.consultas.filter((q) => !publicPaths.has(q.ruta))]
      };
    }
    case 'PARSEO_CONSULTAS_PRIVADAS': {
      return {
        ...state,
        parseoPrivadas: action.payload,
      }
    }
    case 'PARSEO_CONSULTAS_PUBLICAS': {
      return {
        ...state,
        parseoPublicas: action.payload,
      }
    }
    default:
      return state;
  }
};

export default consultaDinamicaReducer;
